/* @flow */

export default class Language {
  id: number;
  name: string;
}
